import { c as _c } from "react/compiler-runtime";
import { Product, useGcssProductList } from '@/api/skippay/gcssProducts';
import { QueryFilter } from '@/utils/query';
import { components } from '@/api/skippay/generated/gcss';
import { useQueryStates, parseAsInteger } from 'nuqs';
import { parseAsSearchString, parseAsFilterArray, parseAsProductSort, parseAsAvailability, parseAsBooleanString } from '@/hooks/searchParamParsers';
import { useBrands } from '@/api/skippay/gcssBrands';
import { parseApiAmount } from '@/utils/amount';
import { useMerchants } from '@/api/skippay/gcssMerchants';
import { useEffect, useMemo, useRef, useState } from 'react';
import { logProductsEvent } from '@/analytics/logProductsEvent';
import { FormApi, createForm } from 'final-form';
const SEARCH_CATEGORY = 'categoryId';
const SEARCH_PRICE = 'priceAmount';
export const FIELD_FULLTEXT = 'fulltext';
export const FIELD_SORT = 'sort';
export const FIELD_AVAILABILITY = 'availability';
export const FIELD_PRICE_FROM = 'priceFrom';
export const FIELD_PRICE_TO = 'priceTo';
export const FIELD_BRAND = 'brand';
export const FIELD_IS_ON_SALE = 'isOnSale';
export const FIELD_MERCHANT = 'merchantName';
export const FIELD_PAGE = 'page';
export type SearchFormValuesGCSS = {
  [FIELD_FULLTEXT]?: string;
  [FIELD_SORT]?: components['schemas']['ProductSort'];
  [FIELD_AVAILABILITY]?: components['schemas']['Availability'];
  [FIELD_PRICE_FROM]?: string;
  [FIELD_PRICE_TO]?: string;
  [FIELD_BRAND]?: string[];
  [FIELD_IS_ON_SALE]?: 'true' | 'false';
  [FIELD_MERCHANT]?: string[];
  [FIELD_PAGE]?: string;
};
export function useGcssValuesToSearch() {
  const $ = _c(27);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      search: parseAsSearchString,
      page: parseAsInteger.withDefault(1).withOptions({
        history: "replace",
        shallow: true,
        throttleMs: 300
      }),
      sort: parseAsProductSort,
      availability: parseAsAvailability,
      priceFrom: parseAsSearchString,
      priceTo: parseAsSearchString,
      brand: parseAsFilterArray,
      isOnSale: parseAsBooleanString,
      merchant: parseAsFilterArray
    };
    t1 = {
      history: "replace",
      shallow: true
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [searchParams, setSearchParams] = useQueryStates(t0, t1);
  const t2 = searchParams.search || undefined;
  let t3;
  if ($[2] !== searchParams.page) {
    t3 = searchParams.page?.toString() || "1";
    $[2] = searchParams.page;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = searchParams.sort || undefined;
  const t5 = searchParams.availability || undefined;
  const t6 = searchParams.priceFrom || undefined;
  const t7 = searchParams.priceTo || undefined;
  const t8 = searchParams.brand && searchParams.brand.length > 0 ? searchParams.brand : undefined;
  const t9 = searchParams.isOnSale || undefined;
  const t10 = searchParams.merchant && searchParams.merchant.length > 0 ? searchParams.merchant : undefined;
  let t11;
  if ($[4] !== t10 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t11 = {
      [FIELD_FULLTEXT]: t2,
      [FIELD_PAGE]: t3,
      [FIELD_SORT]: t4,
      [FIELD_AVAILABILITY]: t5,
      [FIELD_PRICE_FROM]: t6,
      [FIELD_PRICE_TO]: t7,
      [FIELD_BRAND]: t8,
      [FIELD_IS_ON_SALE]: t9,
      [FIELD_MERCHANT]: t10
    };
    $[4] = t10;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const formValues = t11;
  let t12;
  if ($[14] !== setSearchParams) {
    t12 = values => {
      setSearchParams({
        search: values[FIELD_FULLTEXT] || null,
        page: values[FIELD_PAGE] ? parseInt(values[FIELD_PAGE]) : null,
        sort: values[FIELD_SORT] || null,
        availability: values[FIELD_AVAILABILITY] || null,
        priceFrom: values[FIELD_PRICE_FROM] || null,
        priceTo: values[FIELD_PRICE_TO] || null,
        brand: values[FIELD_BRAND] && values[FIELD_BRAND].length > 0 ? values[FIELD_BRAND] : null,
        isOnSale: values[FIELD_IS_ON_SALE] || null,
        merchant: values[FIELD_MERCHANT] && values[FIELD_MERCHANT].length > 0 ? values[FIELD_MERCHANT] : null
      });
    };
    $[14] = setSearchParams;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const sync = t12;
  let t13;
  if ($[16] !== formValues || $[17] !== sync) {
    t13 = () => createForm({
      initialValues: formValues as Partial<SearchFormValuesGCSS>,
      onSubmit: values_0 => {
        sync(values_0);
        return Promise.resolve(values_0);
      }
    });
    $[16] = formValues;
    $[17] = sync;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const [searchForm] = useState(t13);
  let t14;
  let t15;
  if ($[19] !== formValues || $[20] !== searchForm) {
    t14 = () => {
      if (typeof window !== "undefined") {
        searchForm.reset(formValues as Partial<SearchFormValuesGCSS>);
      }
    };
    t15 = [formValues, searchForm];
    $[19] = formValues;
    $[20] = searchForm;
    $[21] = t14;
    $[22] = t15;
  } else {
    t14 = $[21];
    t15 = $[22];
  }
  useEffect(t14, t15);
  let t16;
  if ($[23] !== formValues || $[24] !== searchForm || $[25] !== sync) {
    t16 = {
      formValues,
      sync,
      searchForm
    };
    $[23] = formValues;
    $[24] = searchForm;
    $[25] = sync;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}
export function useGcssSearch(t0) {
  const $ = _c(32);
  const {
    formValues,
    categoryId,
    category,
    subcategory
  } = t0;
  let brandsFilterString;
  let filterString;
  let t1;
  if ($[0] !== categoryId || $[1] !== formValues) {
    let filter = new QueryFilter();
    let brandsFilter = new QueryFilter();
    let merchantsFilter = new QueryFilter();
    const brandFormValues = formValues[FIELD_BRAND];
    const merchantFormValues = formValues[FIELD_MERCHANT];
    if (categoryId) {
      filter = filter.prop(SEARCH_CATEGORY).eq(String(categoryId));
      brandsFilter = brandsFilter.prop(SEARCH_CATEGORY).eq(String(categoryId));
      merchantsFilter = merchantsFilter.prop(SEARCH_CATEGORY).eq(String(categoryId));
    }
    if (formValues[FIELD_FULLTEXT]) {
      filter = filter.prop(FIELD_FULLTEXT).eq(formValues[FIELD_FULLTEXT]);
      brandsFilter = brandsFilter.prop(FIELD_FULLTEXT).eq(formValues[FIELD_FULLTEXT]);
      merchantsFilter = merchantsFilter.prop(FIELD_FULLTEXT).eq(formValues[FIELD_FULLTEXT]);
    }
    if (formValues[FIELD_AVAILABILITY]) {
      filter = filter.prop(FIELD_AVAILABILITY).eq("IN_STOCK" satisfies components['schemas']['Availability']);
      brandsFilter = brandsFilter.prop(FIELD_AVAILABILITY).eq("IN_STOCK" satisfies components['schemas']['Availability']);
      merchantsFilter = merchantsFilter.prop(FIELD_AVAILABILITY).eq("IN_STOCK" satisfies components['schemas']['Availability']);
    }
    if (formValues[FIELD_PRICE_FROM]) {
      filter = filter.prop(SEARCH_PRICE).gt(parseApiAmount(formValues[FIELD_PRICE_FROM]));
      brandsFilter = brandsFilter.prop(SEARCH_PRICE).gt(parseApiAmount(formValues[FIELD_PRICE_FROM]));
      merchantsFilter = merchantsFilter.prop(SEARCH_PRICE).gt(parseApiAmount(formValues[FIELD_PRICE_FROM]));
    }
    if (formValues[FIELD_PRICE_TO]) {
      filter = filter.prop(SEARCH_PRICE).lt(parseApiAmount(formValues[FIELD_PRICE_TO]));
      brandsFilter = brandsFilter.prop(SEARCH_PRICE).lt(parseApiAmount(formValues[FIELD_PRICE_TO]));
      merchantsFilter = merchantsFilter.prop(SEARCH_PRICE).gt(parseApiAmount(formValues[FIELD_PRICE_TO]));
    }
    if (brandFormValues && brandFormValues.length > 0) {
      const brands = Array.isArray(brandFormValues) ? brandFormValues : [brandFormValues];
      filter = filter.prop(FIELD_BRAND).in(brands);
      merchantsFilter = merchantsFilter.prop(FIELD_BRAND).in(brands);
    }
    if (merchantFormValues && merchantFormValues.length > 0) {
      const merchants = Array.isArray(merchantFormValues) ? merchantFormValues.map(_temp) : [(merchantFormValues as string).replace(" cz", "")];
      filter = filter.prop(FIELD_MERCHANT).in(merchants);
      brandsFilter = brandsFilter.prop(FIELD_MERCHANT).in(merchants);
    }
    if (formValues[FIELD_IS_ON_SALE]) {
      filter = filter.prop(FIELD_IS_ON_SALE).eq(formValues[FIELD_IS_ON_SALE]);
      brandsFilter = brandsFilter.prop(FIELD_IS_ON_SALE).eq(formValues[FIELD_IS_ON_SALE]);
      merchantsFilter = brandsFilter.prop(FIELD_IS_ON_SALE).eq(formValues[FIELD_IS_ON_SALE]);
    }
    filterString = filter.conditions.length > 0 ? filter.toString() : undefined;
    brandsFilterString = brandsFilter.conditions.length > 0 ? brandsFilter.toString() : undefined;
    t1 = merchantsFilter.conditions.length > 0 ? merchantsFilter.toString() : undefined;
    $[0] = categoryId;
    $[1] = formValues;
    $[2] = brandsFilterString;
    $[3] = filterString;
    $[4] = t1;
  } else {
    brandsFilterString = $[2];
    filterString = $[3];
    t1 = $[4];
  }
  const merchantsFilterString = t1;
  const t2 = formValues[FIELD_SORT];
  let t3;
  if ($[5] !== filterString || $[6] !== t2) {
    t3 = {
      filter: filterString,
      sort: t2,
      limit: 12
    };
    $[5] = filterString;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const query = useGcssProductList(t3);
  let t4;
  if ($[8] !== brandsFilterString) {
    t4 = {
      filter: brandsFilterString
    };
    $[8] = brandsFilterString;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const brandsQuery = useBrands(t4);
  let t5;
  if ($[10] !== merchantsFilterString) {
    t5 = {
      filter: merchantsFilterString
    };
    $[10] = merchantsFilterString;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const merchantsQuery = useMerchants(t5);
  const queries = [query, brandsQuery, merchantsQuery];
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const cssPartnersPreviousData = useRef(t6);
  let t7;
  if ($[13] !== query.data?.pages) {
    t7 = query.data?.pages.flatMap(_temp2);
    $[13] = query.data?.pages;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const allCssPartners = t7;
  let t8;
  if ($[15] !== allCssPartners || $[16] !== category || $[17] !== query.data?.pages?.length || $[18] !== query.isFetching || $[19] !== subcategory) {
    t8 = () => {
      const difference = allCssPartners?.filter(partner => !cssPartnersPreviousData.current?.includes(partner));
      if (!query.isFetching && difference && difference.length > 0) {
        logProductsEvent(difference, category, subcategory, query.data?.pages?.length);
      }
      cssPartnersPreviousData.current = [...cssPartnersPreviousData.current, ...(difference || [])];
    };
    $[15] = allCssPartners;
    $[16] = category;
    $[17] = query.data?.pages?.length;
    $[18] = query.isFetching;
    $[19] = subcategory;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = query.data?.pages?.length;
  let t10;
  if ($[21] !== allCssPartners || $[22] !== category || $[23] !== query.isFetching || $[24] !== subcategory || $[25] !== t9) {
    t10 = [allCssPartners, category, t9, query.isFetching, subcategory];
    $[21] = allCssPartners;
    $[22] = category;
    $[23] = query.isFetching;
    $[24] = subcategory;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  useEffect(t8, t10);
  const t11 = queries.some(_temp3);
  let t12;
  if ($[27] !== brandsQuery || $[28] !== merchantsQuery || $[29] !== query || $[30] !== t11) {
    t12 = {
      query,
      brandsFilterResult: brandsQuery,
      merchantsFilterResult: merchantsQuery,
      isPending: t11
    };
    $[27] = brandsQuery;
    $[28] = merchantsQuery;
    $[29] = query;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}
function _temp3(q) {
  return q.isPending;
}
function _temp2(subArray) {
  return subArray.data;
}
function _temp(merchant) {
  return merchant.replace(" cz", "");
}